module.exports = __webpack_public_path__ + "img/1540704816.003b2adf.jpg";